import React, { useEffect, useState } from "react";
import ManualReference from "./ManualReference";
import CommonSearch from "components/commonSearch/CommonSearch";
import ReportsServices from "./ReportsServices";
import { CommonUtilities } from "commonUtils";
import PeriodSelectionForm from "components/PeriodSelection/periodSelectionForm";
import { format } from "date-fns";
import ExportOption from "components/Common/exportOption";

export default function AccountingRecognition_Template(param: any) {
    console.log(param)
    let [openFirst, setOpenFirst] = useState(false);
    let [searchFor, setsearchFor] = useState<any>([]);
    let [showCategory, setshowCategory] = useState(false);
    let [activeSubTab, setactiveSubTab] = useState("Recorded Music");
    let [generateArchive_list, setGenerateArchive_List] = useState<any>([]);
    var pagination = { "ReportingArea": activeSubTab, "ReportingClass": "Reporting", searchFor: "" }

    let [manuel_select, setManuelSelect] = useState<any>([]);
    const closeManualReference = (e: any) => {
        console.log(e)

        if (e) {
            manuel_select = e;
            setManuelSelect(manuel_select)
        }
        setOpenFirst(false);
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)
        if (sts === false || sts === true) {
            searchFor = e;
            setsearchFor(e)
            pagination.searchFor = e?.searchFor;
            pagination = { ...pagination, ...searchFor }
            generateArchive_Search();
        }

        if ((sts === true)) {

            generateArchive_Search();
        }
    }

    const generateArchive_Search = () => {
        ReportsServices.generateArchive(pagination).then((value: any) => {
            var obj = (CommonUtilities.relativeDataRemapping(value.data, value.headers.original));
            generateArchive_list = obj
            setGenerateArchive_List(generateArchive_list);
        })
    }



    let [reportingTo, setreportingTo] = useState("");
    let [reportingFrom, setreportingFrom] = useState("");
    let [periodSelection, setperiodSelection] = useState(false);
    const closePeriod = (e: any) => {
        periodSelection = false;
        setperiodSelection(false)
    }

    const onChange = (period: any) => {

        console.log(period)
        if (period.periodFrom) {
            reportingFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            setreportingFrom(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
        }

        if (period.periodTo) {
            reportingTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            setreportingTo(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
        }

        if (period && period.action && period.action === 2) {
            //contractIndicatorList();
        }


    }


    let [exportOption, setExportOption] = useState("");

    const onChangeExportOption = (e: any) => {
        console.log(e)

        if (e.optSts === 1) {

            var payload = {
                pageNumber: -1,
                pageSize: -1,
                fileFormat: e.fileFormat,
                numRows: e.numRows,
                fileName: e.fileName,
                root: "ReportingPack",
                periodNum: ""
            }
            console.log(payload)

            ReportsServices.ReportingPack_Export(payload,e.fileNam);
        }

        exportOption = '';
        setExportOption(exportOption)
    }

    const export_report = () => {
        exportOption = "open"
        setExportOption(exportOption)

    }

    return (

        <div className="ws-12">

            <div className="ws-12 mtl">
                <a className={activeSubTab == "Recorded Music" ? "icon-btn edit active" : "icon-btn edit"} onClick={() => { setactiveSubTab("Recorded Music") }}> Recorded Music </a>
                <a className={activeSubTab == "Mechanical" ? "icon-btn edit active" : "icon-btn edit"} onClick={() => { setactiveSubTab("Mechanical") }}> Mechanical </a>
                <a className={activeSubTab == "Publishing" ? "icon-btn edit active" : "icon-btn edit"} onClick={() => { setactiveSubTab("Publishing") }}> Publishing </a>
            </div>

            <div className="ws-12">

                <div className="ws-12 mt ml">

                    {param && param?.type && param?.type == "Royalty Expense" && <div className="class ws-6 pull-left ptl ">
                        <label className="text-bold text-left pull-left">Period Range</label>
                        <button className="icon-btn edit pull-left m0 p2 ml" type="button" onClick={() => setperiodSelection(true)} title="Select Period">
                            <i className="icon-calendar"></i>
                        </button>
                    </div>}

                    <div className="class ws-6 pull-right" onClick={() => { setOpenFirst(true); }}>
                        <button className="icon-btn edit pull-right mt">Set Manual Reference</button>
                    </div>
                </div>

                <div className="ws-8 paddingCenterBox mtxl pbl">
                    <table className="NewTable overflowVisible">
                        <tbody>
                            <tr className="text-left" style={{ background: '#ebedf9' }}>
                                <td>
                                    <h3 style={{ color: '#47529d' }}>Value</h3>
                                </td>
                                <td>
                                    <h3 style={{ color: '#47529d' }}>Category</h3>
                                </td>
                                {!showCategory && <td width={'100%'}>
                                    <button className="pull-right icon-btn primary" onClick={() => setshowCategory(!showCategory)}><i className="icon-circle-up"></i></button>
                                </td>}
                                {showCategory && <td width={'100%'}>
                                    <button className="pull-right icon-btn primary" onClick={() => setshowCategory(!showCategory)}><i className="icon-circle-down"></i></button>
                                </td>}
                            </tr>

                            {showCategory &&
                                <tr className="text-left pm">
                                    <td>
                                        <label className="control-label mll">All</label>
                                    </td>
                                    <td></td>
                                    <td >
                                        <div className="verticalMediumWide hover-box text-center pull-right ws-2">
                                            <ul className="hover-block textboxDropdownList box overflowVisible ws-12">
                                                <li className="hover-box">
                                                    <button className="icon-btn info mbs"><i className="icon-database"></i>Generate</button>
                                                </li>

                                                {param && param?.type && param?.type == "Royalty Expense" && <li className="hover-box">
                                                    <button className="icon-btn info mbs" onClick={() => export_report()}><i className="icon-download1"></i>Export</button>
                                                </li>}

                                                <li className="hover-box">
                                                    <button className="icon-btn info mbs"><i className="icon-close"></i>Close</button>
                                                </li>
                                            </ul>

                                            <button className="icon-btn edit">
                                                <i className="icon-tag2"></i>Actions
                                            </button>
                                        </div>

                                    </td>
                                </tr>}

                        </tbody>

                    </table>
                </div>

                {manuel_select && manuel_select?.processReferenceId && <div className="ws-12 ptxl">
                    <CommonSearch SearchForHandle={SearchForHandle} type="reportingsGrid" title="Accounts" width="ws-12 pull-left" />
                </div>}

            </div>

            {(() => {
                if (openFirst) {
                    return <ManualReference ManualReferenceOpen={openFirst} closeManualReference={closeManualReference} />
                }
                if (periodSelection === true) {
                    return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={reportingFrom} periodTo={reportingTo} />;
                }

                if (exportOption && exportOption.length > 0) {
                    return <ExportOption exportOption={exportOption} onChange={onChangeExportOption} fileName={(param?.type + '_' + param?.subType).replace(/ /g, "")} />
                }

            })()}

        </div>
    )
}